import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Card, Collapse, Radio, Text } from "@nextui-org/react";
import React, { useState } from "react";
import { NEW } from "../context";
import { ago } from "../helpers";
export var ResumePicker = function ResumePicker(_ref) {
  var defaultResume = _ref.defaultResume,
      onResumeChange = _ref.onResumeChange,
      resumes = _ref.resumes;

  var _useState = useState(defaultResume),
      _useState2 = _slicedToArray(_useState, 2),
      currentResume = _useState2[0],
      setCurrentResume = _useState2[1];

  if (!(resumes !== null && resumes !== void 0 && resumes.length)) {
    return /*#__PURE__*/React.createElement(Card, null, "No resumes found. Create one?");
  }

  var isNewResume = currentResume === NEW || currentResume === undefined;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Collapse.Group, null, /*#__PURE__*/React.createElement(Collapse, {
    title: "Resume"
  }, /*#__PURE__*/React.createElement(Radio.Group, {
    value: currentResume !== null && currentResume !== void 0 ? currentResume : NEW
  }, isNewResume && /*#__PURE__*/React.createElement(Radio, {
    value: NEW,
    key: NEW
  }, /*#__PURE__*/React.createElement("em", null, "New resume")), resumes.map(function (resume) {
    return /*#__PURE__*/React.createElement(Radio, {
      value: resume.id,
      key: resume.id,
      disabled: isNewResume,
      onChange: function onChange(e) {
        if (e.target.checked) {
          if ((onResumeChange === null || onResumeChange === void 0 ? void 0 : onResumeChange(resume.id)) === false) {
            e.preventDefault();
            return;
          }

          setCurrentResume(resume.id);
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column"
      }
    }, /*#__PURE__*/React.createElement(Text, null, resume.displayName || /*#__PURE__*/React.createElement("em", null, "Untitled resume")), (resume.modified || resume.created) && /*#__PURE__*/React.createElement(Text, {
      css: {
        fontSize: "0.6rem"
      }
    }, ago(resume.modified || resume.created))));
  })))));
};